import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

interface IProps {
  isAuthenticated: boolean
  component: any
  exact: any
  path: any
}

const ProtectedRoute: React.FunctionComponent<IProps> = ({
  isAuthenticated,
  component,
  ...rest
}) => {
  const Component = component
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  )
}

ProtectedRoute.defaultProps = {
  isAuthenticated: false,
}

export default connect((state: { auth: any }) => ({
  isAuthenticated: !!state.auth.token,
}))(ProtectedRoute)
